// A safe internal path starts with a single "/" (not "//", which the browser
// treats as a protocol-relative external URL) and contains no backslash (which
// some browsers normalise to "/"). This blocks open-redirect targets such as
// "//evil.com", "https://evil.com", and "javascript:..." while allowing normal
// in-app paths like "/dashboard" or "/admin/users".
const SAFE_INTERNAL_PATH = /^\/(?!\/)[^\\]*$/;

/**
 * Returns `redirect` only when it is a safe in-app path; otherwise returns
 * `fallback`. Redirects back into the login flow are rejected too, since they
 * would bounce the user straight back to /login after authenticating.
 */
export function toSafeInternalPath(
	redirect: string | undefined,
	fallback = "/dashboard"
): string {
	if (!redirect || !SAFE_INTERNAL_PATH.test(redirect)) {
		return fallback;
	}
	if (redirect === "/login" || redirect.startsWith("/login?")) {
		return fallback;
	}
	return redirect;
}
